import styled from 'styled-components';

const FormGroup = styled.div`
  position: relative;
  padding-bottom: 2.4rem;
`;

export { FormGroup };
